import { MyTextarea } from "./styles"

export const Textarea = (props) => {
    const { placeholder, value, onChange, rows } = props
    return (
        <MyTextarea
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            rows={rows}
        />
    )
}